import { Button, Breadcrumb, BPanel } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import React from 'react';

import { Meteor } from 'meteor/meteor';
import { Reactive } from '../common/Reactive.mixin.js';

import { UserSchema } from '../../collections/users/users';
import MgfTableComponent from '../common/mgfTable';

@Reactive({
	subscriptions: ["users"],
	users: Meteor.users.find({roles:{$in:['partner']}}),
})
export default class PartnerListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Utilisateurs
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des utilisateurs
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/users/add"><Button bsStyle="success">Ajouter</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des utilisateurs">
					{ this.props.isReady && 
						<MgfTableComponent fields={UserSchema._schema} list={this.props.users} type='partners'></MgfTableComponent> 
					}
				</BPanel>
			</div>
		);
	}
}

PartnerListPage.propTypes = {
	users: React.PropTypes.array.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/partners/PartnerList.page.js
 **/